var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint react/no-danger:0 */
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-stars'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/react-stars/dist/react-stars.js' implicitly has an 'any' type.
import ReactStars from "react-stars";
import moment from "moment";
import AvisoForm from "../shared/form/form";
import AvisoMap from "../shared/googleMap";
import ShareModal from "./shareModal";
import AvisoLayout from "../shared/layout";
import AvisoDiv from "../shared/div";
import SEO from "../../src/View/UI/SEO/SEO";
import A11yHelpers from "../../util/A11yHelpers";
import { AlertError } from "../../src/View/UI/StandardAlerts/StandardAlerts";
import { getXSRF } from "../../src/Services/Shared/FetchService";
const commentForm = [
    [
        {
            property: "rating",
            label: "Stars",
            placeholder: "",
            defaultValue: 0,
            type: "stars",
            // @ts-expect-error - TS2322 - Type '{ property: string; label: string; placeholder: string; defaultValue: number; type: string; rows: number; helpText: string; value: number; isRequired: false; disabled: false; half: false; containerClass: string; }' is not assignable to type 'Input<any>'.
            rows: 0,
            helpText: "",
            value: 0,
            isRequired: false,
            disabled: false,
            half: false,
            containerClass: "form-group mt-2",
        },
    ],
    [
        {
            property: "comment",
            label: "Comment",
            labelClass: "",
            placeholder: "",
            defaultValue: "",
            type: "textarea",
            // @ts-expect-error - TS2322 - Type '{ property: string; label: string; labelClass: string; placeholder: string; defaultValue: string; type: string; rows: number; helpText: string; value: string; isRequired: false; isValid: (v: string, i: Input<...>) => boolean; errorMessage: string; containerClass: string; }' is not assignable to type 'Input<any>'.
            rows: 3,
            helpText: "",
            value: "",
            isRequired: false,
            isValid: (v, i) => !!v && v.length < 1001,
            errorMessage: "Please provide a comment that is no longer than 1000 characters.",
            containerClass: "form-group",
        },
    ],
];
class Resources extends PureComponent {
    constructor(props) {
        super(props);
        this.fetchResource = this.fetchResource.bind(this);
        this.saveRating = this.saveRating.bind(this);
        this.renderNav = this.renderNav.bind(this);
        this.onCommentFormError = this.onCommentFormError.bind(this);
        this.renderRatingEvent = this.renderRatingEvent.bind(this);
        this.state = {
            loading: true,
            resource: null,
            category: null,
            links: [],
            errorMessage: "",
            successMessage: "",
            canManage: false,
            canShare: false,
            isUser: false,
            commentErrorMessage: "",
        };
        this.fetchResource();
    }
    onCommentFormError(data, e) {
        if (!this.state.resource) {
            this.setState({
                commentErrorMessage: "There was an error saving your comment. Please reload and try again.",
            });
            this.scrollToComments();
            return false;
        }
        if (!data.rating) {
            this.setState({
                commentErrorMessage: "Please give a star rating for your review.",
            });
            this.scrollToComments();
            return false;
        }
        return true;
    }
    saveRating(data, e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            console.log("DATA: ", data);
            if (!this.onCommentFormError(data, e)) {
                return;
            }
            if (!data.comment) {
                this.setState({
                    commentErrorMessage: "Please provide a comment for your review.",
                });
                return;
            }
            const { resourceId } = this.props.match.params;
            const request = yield fetch("/aviso/resourceGuide/rateResource", {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(Object.assign(Object.assign({}, data), { resourceId })),
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
            });
            const response = yield request.json();
            if (response.success) {
                const resource = JSON.parse(JSON.stringify(this.state.resource));
                const ratings = resource.resourceRatingEvents;
                ratings.push(response.data);
                resource.averageRating =
                    ratings.length > 1
                        ? (resource.averageRating + data.rating) / 2
                        : data.rating;
                resource.currentUserHasReviewed = true;
                this.setState({ resource, commentErrorMessage: "" });
            }
            else {
                this.setState({
                    commentErrorMessage: "There was an error saving your comment. Please reload and try again.",
                });
            }
        });
    }
    fetchResource() {
        return __awaiter(this, void 0, void 0, function* () {
            const { resourceId, categoryId } = this.props.match.params;
            const response = yield fetch(`/aviso/resourceGuide/getResource?id=${resourceId}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            console.log(result);
            if (!result.success) {
                if (result.data &&
                    typeof result.data.isUser !== "undefined" &&
                    !result.data.isUser) {
                    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location'.
                    window.location = window.location.href.replace("category", "categoryAuth");
                    return;
                }
                if (result.data &&
                    typeof result.data.message !== "undefined" &&
                    result.data.message) {
                    this.setState({ loading: false, errorMessage: result.data.message });
                    return;
                }
                if (result.message) {
                    this.setState({ loading: false, errorMessage: result.message });
                }
                else {
                    this.setState({
                        loading: false,
                        errorMessage: "There was an error loading this resource.",
                    });
                }
                return;
            }
            const { resource, category, canManage, canShare, isUser } = result.data;
            const links = [
                { anchor: "Categories", link: "/aviso/app/resourceGuide/index" },
                {
                    link: `/aviso/app/resourceGuide/category/${categoryId}`,
                    anchor: category.name,
                },
                { link: "", anchor: result.name },
            ];
            this.setState({
                category,
                resource,
                links,
                loading: false,
                canManage,
                canShare,
                isUser,
            });
            console.log(response.url, result);
        });
    }
    removeComment(comment) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!comment.id) {
                this.setState({
                    errorMessage: "There was an error removing the selected comment. Please reload and try again.",
                });
                return;
            }
            const response = yield fetch(`/aviso/resourceGuide/removeComment?id=${comment.id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
            });
            const result = yield response.json();
            if (!result.success) {
                if (result.data &&
                    typeof result.data.message !== "undefined" &&
                    result.data.message) {
                    this.setState({ errorMessage: result.data.message });
                    return;
                }
                this.setState({
                    errorMessage: "There was an error removing the selected comment. Please reload and try again.",
                });
                return;
            }
            const { resource } = result.data;
            this.setState({ resource });
            console.log(response.url, result);
        });
    }
    renderError(error) {
        if (error) {
            return _jsx(AlertError, { message: error });
        }
        return null;
    }
    renderRatingEvent(ratingEvent, key) {
        return (_jsxs("div", { className: "row", children: [_jsxs("div", { className: "col", children: [_jsx(ReactStars, { color2: "#ffd700", count: 5, edit: false, size: 18, value: ratingEvent.resourceRating }), _jsx("small", { className: "muted", children: moment(ratingEvent.date, moment.ISO_8601).calendar() }), _jsx("p", { children: ratingEvent.comment })] }), _jsx(AvisoDiv, { show: this.state.canManage, children: _jsx("div", { className: "col-2 justify-content-end d-flex", children: _jsxs("button", Object.assign({ className: "btn btn-link" }, A11yHelpers.onClickOrEnterOrSpace(() => this.removeComment(ratingEvent)), { children: [_jsx("span", { className: "sr-only", children: "Remove Comment" }), _jsx("i", { "aria-hidden": "true", className: "fa fa-trash m-1 text-danger btn btn-link" })] })) }) })] }, `rating-${key}`));
    }
    renderReviewBox(hasBeenReviewed, commentsDisabled) {
        if (!hasBeenReviewed && !commentsDisabled) {
            return (_jsxs("span", { id: "commentBlock", children: [this.renderError(this.state.commentErrorMessage), _jsxs("b", { children: ["Help Others!", this.state.resource &&
                                this.state.resource.resourceRatingEvents.length
                                ? " "
                                : " Be the First to ", "Review this Resource"] }), _jsx(AvisoForm, { className: "pb-3", form: commentForm, onError: this.onCommentFormError, onSubmit: this.saveRating })] }));
        }
        return null;
    }
    renderMap(lat, lng) {
        if (!lat || !lng) {
            return null;
        }
        const mapProps = {
            loadingElement: _jsx("div", { style: { height: "100%" } }),
            containerElement: _jsx("div", { className: "mb-3", style: { height: "300px" } }),
            mapElement: _jsx("div", { style: { height: "100%" } }),
            isMarkerShown: true,
            lat,
            lng,
        };
        return _jsx(AvisoMap, Object.assign({}, mapProps));
    }
    renderNav() {
        const { categoryId, resourceId } = this.props.match.params;
        const { resource } = this.state;
        return (_jsxs("span", { children: [_jsx(AvisoDiv, { show: this.state.canManage, children: _jsxs(Link, { className: "btn btn-link", title: "Edit Resource", to: `/aviso/app/resourceGuide/category/${categoryId}/resource/${resourceId}/edit`, children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-pencil-alt mr-1" }), _jsx("span", { className: "d-none d-md-inline-block", children: "Edit" })] }) }), resource && (_jsxs("span", { children: [_jsx(AvisoDiv, { show: !!resource.url, children: _jsxs("a", { className: "btn btn-link", href: resource.url, target: "_blank", rel: "noopener noreferrer", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-desktop mr-1" }), _jsx("span", { className: "d-none d-md-inline-block", children: "Website" })] }) }), _jsx(AvisoDiv, { show: !!resource.addressLine1, children: _jsxs("a", { className: "btn btn-link", href: `https://maps.google.com/?q=${resource.addressLine1 || ""}`, target: "_blank", rel: "noopener noreferrer", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-map-pin mr-1" }), _jsx("span", { className: "d-none d-md-inline-block", children: "Directions" })] }) }), _jsx(AvisoDiv, { show: this.state.canShare && !!this.state.resource, children: _jsxs("button", { className: "btn btn-link", "data-target": "#shareModal", "data-toggle": "modal", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-share-alt mr-1" }), _jsx("span", { className: "d-none d-md-inline-block", children: "Share" })] }) })] }))] }));
    }
    renderAddress(address) {
        if (address) {
            return (_jsx(AvisoDiv, { show: !!address, children: _jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Address" }), _jsx("br", {}), _jsx("a", { href: `https://maps.google.com/?q=${address}`, target: "_blank", rel: "noopener noreferrer", children: address })] }) }));
        }
        return null;
    }
    renderPhoneNumber(number, extension, label) {
        if (number) {
            return (_jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Phone Number" }), _jsx("br", {}), _jsx("a", { href: `tel:+1${number}`, children: label })] }));
        }
        return null;
    }
    renderEmail(email) {
        if (email) {
            return (_jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Email" }), _jsx("br", {}), _jsx("a", { href: `mailto:${email}`, children: email })] }));
        }
        return null;
    }
    renderBadge(active) {
        if (active) {
            return (_jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Status" }), _jsx("br", {}), _jsx("small", { className: "badge badge-pill badge-success", children: "Active" })] }));
        }
        return (_jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Status" }), _jsx("br", {}), _jsx("small", { className: "badge badge-pill badge-danger", children: "Inactive" })] }));
    }
    renderContact(contactName) {
        if (!contactName) {
            return null;
        }
        return (_jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Primary Contact" }), _jsx("br", {}), contactName] }));
    }
    renderComments(resource, isUser) {
        if (!resource || resource.commentsDisabled) {
            return null;
        }
        if (!isUser) {
            return (_jsx("div", { className: "alert alert-info", role: "alert", children: "Please log in to view comments." }));
        }
        return (_jsxs("span", { children: [_jsx("hr", {}), this.renderReviewBox(resource.currentUserHasReviewed, resource.commentsDisabled), _jsx(AvisoDiv, { show: !!resource.resourceRatingEvents.length, children: _jsx("div", { className: "row justify-content-center", children: _jsx("div", { className: "col", children: _jsxs("h4", { className: "header", children: ["Reviews (", resource.resourceRatingEvents.length, ")"] }) }) }) }), resource.resourceRatingEvents.map(this.renderRatingEvent)] }));
    }
    scrollToComments() {
        const e = document.getElementById("commentBlock");
        if (e === null || e === void 0 ? void 0 : e.scrollIntoView) {
            e.scrollIntoView();
        }
    }
    render() {
        let { resource } = this.state;
        if (!resource) {
            resource = {
                id: 0,
                name: "",
                resourceRatingEvents: [],
                averageRating: 0,
                active: false,
                addressLine1: "",
                phoneNumber: "",
                phoneExtension: "",
                phoneNumberFormatted: "",
                primaryContactName: "",
                primaryContactEmail: "",
                geolat: 0,
                geolng: 0,
                description: "",
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Date | null | undefined'.
                modifiedDate: new Date().toString(),
                commentsDisabled: true,
            };
        }
        return (_jsx(AvisoLayout, { renderNav: this.renderNav, children: _jsx(AvisoDiv, { error: !!this.state.errorMessage, errorMessage: this.state.errorMessage, 
                // @ts-expect-error - TS2769 - No overload matches this call.
                loading: this.state.loading, children: _jsxs("div", { children: [_jsx(SEO, { title: resource.name }), _jsxs("div", { children: [_jsx("nav", { children: _jsxs("ol", { className: "breadcrumb pl-0", children: [_jsx("li", { className: "breadcrumb-item", children: _jsx(Link, { to: "/aviso/app/resourceGuide/index", children: "Resource Guide" }) }), this.state.category && (_jsx("li", { className: "breadcrumb-item", children: _jsxs(Link, { to: `/aviso/app/resourceGuide/category/${this.state.category.id}`, children: [this.state.category.name, _jsx("span", { className: "sr-only", children: this.state.category.name })] }) })), _jsx("li", { className: "breadcrumb-item active", children: resource.name })] }) }), _jsx("h1", { children: resource.name }), _jsx(AvisoDiv, { show: 
                                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                    !!resource.resourceRatingEvents.length &&
                                        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                        !resource.commentsDisabled, children: _jsx("div", { className: "form-group", children: _jsx("button", { className: "btn btn-link p-0", onClick: this.scrollToComments, children: _jsx(ReactStars, { color2: "#ffd700", count: 5, edit: false, size: 12, 
                                                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                value: resource.averageRating }) }) }) }), _jsxs("div", { className: "my-3", children: [_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-sm-12 col-md-8 col-lg-9", children: (resource === null || resource === void 0 ? void 0 : resource.description) ? (_jsx("p", { dangerouslySetInnerHTML: {
                                                            __html: resource.description,
                                                        } })) : ((resource === null || resource === void 0 ? void 0 : resource.externalResourceUrl) && (_jsxs("p", { children: ["Click", " ", _jsx("a", { href: resource.externalResourceUrl, children: " here " }), " to go to external resource"] }))) }), _jsx("div", { className: "col-sm-12 col-md-4 col-lg-3", children: _jsx("div", { className: "card bg-gray", children: _jsxs("div", { className: "card-body", children: [this.renderAddress(resource.addressLine1), this.renderContact(resource.primaryContactName), this.renderPhoneNumber(
                                                                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                                resource.phoneNumber, 
                                                                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                                resource.phoneExtension, 
                                                                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                                resource.phoneNumberFormatted), this.renderEmail(resource.primaryContactEmail), _jsx(AvisoDiv, { show: this.state.canManage, children: this.renderBadge(resource.active) }), _jsxs("div", { className: "form-group", children: [_jsx("b", { children: "Last Updated" }), _jsx("br", {}), moment(
                                                                        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                                        resource.modifiedDate, moment.ISO_8601).format("ddd M/D/YYYY h:mm a ")] })] }) }) })] }), this.renderComments(this.state.resource, this.state.isUser)] })] }), this.state.resource && (_jsx(ShareModal, { id: "shareModal", resource: this.state.resource }))] }) }) }));
    }
}
export default Resources;
